import { storeRequester } from "App";
import { createContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import useAltEffect from "shared/hooks/useAltEffect";
import useLocalStorage from "shared/hooks/useLocalStorage";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";
import { RegionReducer } from "shared/redux/reducers/region/RegionReducer";
import {
  getRoleFromTokenPayload,
  getTokenPayload,
  removeLocalStorage,
} from "shared/utils/Utils";

export const AuthContext = createContext({
  userName: String,
  userInfo: Object,
  isAuthenticated: Boolean,
  authCheckDone: Boolean,
});

function AuthProvider(props) {
  const [userName, setUserName] = useState("");
  const [isAuthenticated, setAuthenticated] = useState(false);
  const { token } = useSelector((state) => ({
    token: state.auth.token,
  }));
  const dispatch = useDispatch();
  const [userInfo, setUserIfo] = useState();

  useAltEffect(() => {
    if (token) {
      try {
        const tokenPayload = getTokenPayload(token);

        if (tokenPayload) {
          let { exp } = tokenPayload;
          if (Date.now() >= exp * 1000) {
            removeLocalStorage("token");

            window.location.reload();
          } else {
            setUserName(tokenPayload.customer_id);
            setAuthenticated(true);
            storeRequester.getCurrentCustomer(
              {
                expand: "groups"
              },
              ({ customer }) =>
                setUserIfo(customer)
            );
          }
        }
      } catch (e) { }
    } else {
      setUserName(null);
      setAuthenticated(false);
    }
  }, [token]);
  
  return (
    <AuthContext.Provider value={{ userName, isAuthenticated, userInfo }}>
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;
